<template>
  <v-container class="px-0 my-3" v-if="order != null">
    <v-row class="d-flex flex-wrap justify-content-start">
      <v-col class="v-col-12 v-col-lg-4">
        <v-row class="bg-white pa-2">
          <v-col class="v-col-12 d-flex align-center">
            <b class="text-color-0">Acompanhe seu pedido</b>
          </v-col>
          <v-col class="v-col-5 d-flex align-center justify-center">
            <v-icon icon="mdi-check-circle-outline" size="130px" class="text-color-green"></v-icon>
          </v-col>
          <v-col class="v-col-7">
            <v-row>
              <v-col cols="12" class="text-center">
                <b class="text-xlarge text-color-green">Pedido Confirmado</b>
              </v-col>
              <v-col cols="12" class="text-center">
                <b class="text-xlarge">{{ getLastorder }}</b>
              </v-col>
              <v-col cols="12" class="text-center">
                <span class="text-color-0">{{ $formatDate(order.finish_date + " 00:00:00") }} às {{ order.finish_hour }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="bg-white pa-2 mt-7">
          <v-col class="v-col-6">
            <span class="text-color-0">Valor da Compra</span>
          </v-col>
          <v-col class="v-col-6 text-end">
            <span class="text-color-1">{{ $formatNumber(order.value, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6">
            <span class="text-color-0">Frete</span>
          </v-col>
          <v-col class="v-col-6 text-end">
            <span class="text-color-1" v-if="order.shipping_fee > 0">+ {{ $formatNumber(order.shipping_fee, {style: 'currency', currency: 'BRL'}) }} </span>
            <span class="text-color-green" v-else>Grátis</span>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="order.value_discounts > 0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6" v-if="order.value_discounts > 0">
            <span class="text-color-0">Descontos</span>
          </v-col>
          <v-col class="v-col-6 text-end" v-if="order.value_discounts > 0">
            <span class="text-color-green">- {{ $formatNumber(order.value_discounts, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="order.wallet_value > 0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6" v-if="order.wallet_value > 0">
            <span class="text-color-0">Carteira Digital</span>
          </v-col>
          <v-col class="v-col-6 text-end" v-if="order.wallet_value > 0">
            <span class="text-color-green">- {{ $formatNumber(order.wallet_value, {style: 'currency', currency: 'BRL'}) }}</span>
          </v-col>
          <v-col cols="12" class="pa-0">
            <hr class="fine-line">
          </v-col>
          <v-col class="v-col-6">
            <b class="text-color-0 text-xlarge">Valor Total</b>
          </v-col>
          <v-col class="v-col-6 text-end">
            <b class="text-color-1 text-xlarge">{{ $formatNumber(order.total_final, {style: 'currency', currency: 'BRL'}) }}</b>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="v-col-12 v-col-lg-8">
        <v-row class="ms-lg-1 bg-white pb-3 text-color-0">
          <v-col class="v-col-12">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Forma de Pagamento</div>
            <div v-if="order.is_online_payment == 0" class="pa-2">
              <b>Pagamento na {{ order.destiny_type ? 'Entrega': 'Retirada' }}</b><br>
              <span>{{ order.payment_method }}</span>
              <br>
              <span v-if="order.change_value > 0">Necessita troco para <b>{{ $formatNumber(order.change_value, {style: 'currency', currency: 'BRL'}) }}</b></span>
            </div>
            <div v-if="order.is_online_payment == 1" class="pa-2">
              Pagamento Online<br>
              {{ order.payment_method }}
            </div>
            <div v-if="order.is_online_payment == 1 && order.payment_method == 'Pix' && pix != null" class="pa-2">
              <v-row>
                <v-col cols="3">
                  <v-img :src="pix.qr_code_base64"></v-img>
                </v-col>
                <v-col cols="9">
                  Copia e Cola:<br>
                  <b @click="copiarTexto()" style="cursor: copy; word-break: break-word;">{{ pix.pix_copy_paste }}</b> <v-chip v-if="copiado" size="x-small" color="green" variant="flat">Copiado!</v-chip>
                  <br><br>
                  Após o pagamento, favor enviar o comprovante para o número de Whatsapp: <b>{{ pix.contact_phone }}</b>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col class="v-col-12">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Endereço de {{ order.destiny_type ? 'Entrega': 'Retirada' }}</div>
            <div class="pa-2">
              <div v-if="order.address_nickname != '' && order.address_nickname != null"><b>{{ order.address_nickname }}</b><br></div>
              {{ order.street }}, {{ order.number }}<br>
              {{ order.district }} - {{ order.city }} - {{ order.state }}<br>
              <b>CEP:</b> {{ order.zip_code }}<br>
              <b v-if="order.complement != ''">Complemento:</b> {{ order.complement }}
            </div>
          </v-col>
          <v-col class="v-col-12">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Data da {{ order.destiny_type ? 'Entrega': 'Retirada' }}</div>
            <div class="pa-2">
              <span class="text-capitalize">{{ $formatDate(order.delivery_date+" 00:00:00", { weekday: "long" }) }},</span><br>
              Das {{ order.delivery_ihour.split(":")[0]+"h"+order.delivery_ihour.split(":")[1] }} às {{ order.delivery_fhour.split(":")[0]+"h"+order.delivery_fhour.split(":")[1] }}<br>
              <span>Pessoa que irá receber: <b>{{ order.res_name_withdrawal != "" ? order.res_name_withdrawal : getUserInfo.name }}</b></span> <span v-if="order.res_doc_withdrawal != ''">({{ order.res_doc_withdrawal }})</span>
            </div>
          </v-col> 
          <v-col class="v-col-12" v-if="order.obs != ''">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Observação</div>
            <div class="pa-2">
              <span>{{ order.obs }}</span>
            </div>
          </v-col>
          <v-col class="v-col-12">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Caso falte algum produto da sua compra</div>
            <div class="pa-2">
              <span v-if="order.opt_missing == 1">Substituir por produto similar e de preço semelhante</span>
              <span v-if="order.opt_missing == 2">Excluir o item da minha compra</span>
              <span v-if="order.opt_missing == 3">Desejo receber contato pelo número: <b>{{ order.opt_missing_obs }}</b></span>
            </div>
          </v-col>
          <v-col class="v-col-12">
            <div class="title-revisao text-start pa-2 font-weight-bold rounded">Produtos</div>
            <v-list class="w-100 pa-0 ma-0 rounded-0" v-for="i in order.itens" :key="i.category">
              <v-list-item class="bg-color-gray text-color-0 text-start text-small py-0">{{ i.category }} ({{ i.qtd }} {{ i.qtd > 1 ? ' itens':' item' }})</v-list-item>
              <v-list-item v-for="p in i.itens" :key="p.name" class="border-bottom list-cart pa-0">
                <v-row class="ma-0">
                  <v-col class="v-col-1 d-flex align-center justify-center cursor-pointer pa-0">
                    <ImageProduct :image="p.image"></ImageProduct>
                  </v-col>
                  <v-col class="v-col-7 text-color-0 text-small d-flex align-center">
                    {{ p.name }}
                  </v-col>
                  <v-col class="v-col-2 text-color-0 text-small d-flex align-center">
                    {{ p.is_kg == 1 ? textQtd(p.amount) : textUnd(p.amount) }}
                  </v-col>
                  <v-col class="v-col-2 text-color-0 text-small d-flex align-center justify-end">
                    {{ $formatNumber(p.total_price, {style: 'currency', currency: 'BRL'}) }}
                  </v-col>
                  <v-col v-if="p.obs != '' && p.obs != null" class="v-col-12 text-color-0 text-small d-flex align-center">
                    <p><b>Obs.:</b> {{ p.obs }}</p>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ImageProduct from '@/components/ImageProduct.vue';
export default {
  name: 'Pedido',
  components: {
    ImageProduct
  },
  data(){
    return {
      order: null,
      pix: null,
      copiado: false
    }
  },
  computed: {
    ...mapGetters('order', {
      getLastorder: 'getLastorder'
    }),
    ...mapGetters('user', {
      getUserInfo: 'getUserInfo'
    }),
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    ...mapActions('order', {
      getOrderDetails: 'getOrderDetails',
      getPix: 'getPix'
    }),
    ...mapActions('products', {
      getImageCarousel: 'getImageCarousel'
    }),
    ...mapActions('user', {
      userResume: 'userResume'
    }),
    copiarTexto() {
      navigator.clipboard.writeText(this.pix.pix_copy_paste).then(() => {
        this.copiado = true;
      });
    },
    textQtd: function (qtd) {
      if (qtd < 1) {
          return Number(Math.round((qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(qtd) ? (Number(Math.round((qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    },
    textUnd: function (qtd) {
      if (qtd == 1) {
          return qtd + ' und';
      } else {
          return qtd + ' unds';
      }
    },
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        if(this.getLastorder != 0){
          this.userResume();
          this.getOrderDetails(this.getLastorder).then(function(response){
            if(response.cod == "100"){
              this.order = response.return;
              let orders = [];
              if(this.order.is_online_payment == 1 && this.order.payment_method == 'Pix'){
                this.getPix({order_id: this.getLastorder}).then(function(retorno){
                  this.pix = retorno;
                }.bind(this));
              }
              this.order.itens.forEach(element => {
                this.getImageCarousel({ imghash: "t-"+element.imghash }).then(function(image){
                  element.image = image;
                }.bind(this));
                const cat = orders.find(c => c.category == element.category);
                if(cat){
                  cat.itens.push(element);
                  cat.total += element.total_price;
                  cat.qtd += 1;
                } else {
                  orders.push({
                    category: element.category,
                    itens: [element],
                    qtd: 1
                  });
                }
              });
              this.order.itens = orders;
              this.order.total_final = this.order.value + this.order.shipping_fee - this.order.wallet_value - this.order.value_discounts;
            } else {
              this.$router.push('/');
            }
          }.bind(this));
        } else {
          this.$router.push('/');
        }
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  }
}
</script>